
import { Link, useLoaderData,  useLocation,  useNavigate } from "react-router-dom";
import { Button } from "../components/Button";
import { useEffect, useRef, useState } from "react";
import {  TextField } from "../components/TextField";
import { Select } from "../components/Select";
import { Form } from "react-router-dom";
import {  _getOrderItems, _getServiceItems, _getTicketStatusOptions, _getTicketTagOptions, createOrderTicket, createVehicleServiceTicket, editOrderTicket, editVehicleServiceTicket, getCustomerByName, getCustomers, getCustomerVehicles, getOrderDetails, getOrderTicket, getOrderTicketItems, getServiceDetails, updateServiceTicketStatus, sendFeedbackEmail, sendReceivedByEmail, sendNextServiceNotification } from "../services/api";
import { capitalize, formatDate, getUserId, getUserPermission } from "../services/helpers";
import mixpanel from "../services/mixpanel";
import ESelect from 'react-select';

export function AddTicket(){
	// const [showDialog, setShowDialog] = useState(false);
	const [serviceItemsList,setServiceItemsList] = useState([]);
	const [_serviceItems,_setServiceItems] = useState([]);
	const [isSubmitting,setIsSubmitting] = useState(false);

	const urlParams = new URLSearchParams(window.location.search);

	const navigate = useNavigate();
	const locationState = useLocation().state;
	const userPermission = getUserPermission();
	const _currentService = null;
	const [_customerId, setCustomerId] = useState(undefined);
	const [ _serviceDate,_setServiceDate] = useState("null");
	const [_ticketTags,_setticketTags] = useState([]);
	const [ticketTag,setTicketTag] = useState([]);
	const [_newItemSubTotal, _setNewItemSubTotal] = useState(0);
	const _defaultNewItemName = "Enter Item Name Here";
	const _defaultNewItemDescription = "Enter description here"
	const [showStatusDialog,setShowStatusDialog] = useState(null);
	const [showFeedbackEmailDialog,setShowFeedbackEmailDialog] = useState(false);
	const [scheduledEmailDate, setScheduledEmailDate] = useState('');
	const [customerEmail, setCustomerEmail] = useState('');
	const [customerName, setCustomerName] = useState('');
	const [currentTicketId, setCurrentTicketId] = useState(null);
	const [showVehicleReceivedDialog, setShowVehicleReceivedDialog] = useState(false);
	const [receivedBy, setReceivedBy] = useState('');
	const [droppedOffBy, setDroppedOffBy] = useState('');
	const [showNextServiceDialog, setShowNextServiceDialog] = useState(false);
	const [nextServiceDate, setNextServiceDate] = useState('');
	const [_statusOptions,_setStatusOptions] = useState(["open"]);
	const [discountType,setDiscountType] = useState(_currentService?.discount_type == null ? "None" :capitalize(_currentService.discount_type));
	const [discountValue,setDiscountValue] = useState(_currentService?.discount_value ?? 0);
	const canPopulate = useRef(true); // tracks if locationState data has been populated;

	//New variables
	const [customerVehicles, setCustomerVehicles] = useState([]);
	const [_customerList,_setCustomerList] = useState([]);
	const [_customerFilter,_setCustomerFilter] = useState('');
	const [_vehicleId,_setVehicleId] = useState(undefined);
	const [_isLoadingVehicles, _setIsLoadingVehicles] = useState(false);
	const [_isCustomerListLoading, setIsCustomerListLoading] = useState(false);




	function updateStatus(e){
		e.preventDefault();
		const formData = new FormData(e.target);
		const newStatus = formData.get("status");

		updateServiceTicketStatus({
			"ticket_id": showStatusDialog,
			"new_status": newStatus
		});
		setCurrentTicketId(showStatusDialog);


		if (newStatus === 'complete') {
			const threeDaysFromNow = new Date();
			threeDaysFromNow.setDate(threeDaysFromNow.getDate() + 3);
			setScheduledEmailDate(threeDaysFromNow.toISOString().split('T')[0]);
			const customer = _customerList.find(customer => customer.uuid === _customerId);
			setCustomerEmail(customer?.email || '');
			setCustomerName(`${customer?.first_name} ${customer?.last_name}` || '');

			if(ticketTag.map(e=>e.toLowerCase()).includes("servicing")){
				const threeMonthsFromNow = new Date();
				threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth()+3);
				setNextServiceDate(threeMonthsFromNow.toISOString().split('T')[0]);
				setShowNextServiceDialog(true);
			}else{
			setShowFeedbackEmailDialog(true);

			}
		setShowStatusDialog(null);
		} else if (newStatus === 'open') {
			const customer = _customerList.find(customer => customer.uuid === _customerId);
			setCustomerEmail(customer?.email || '');
			setCustomerName(`${customer?.first_name} ${customer?.last_name}` || '');

			setShowStatusDialog(null);
			setShowVehicleReceivedDialog(true);
		}else{
		setShowStatusDialog(null);
			continueToNextPage();
		}

	}

	async function sendEmail(isScheduled = false) {
		const emailData = {
			customer_email: customerEmail,
			customer_name: customerName,
			ticket_id: currentTicketId
		};

		if (isScheduled) {
			emailData.schedule_at = scheduledEmailDate;
		}

		try {
			const response = await sendFeedbackEmail(emailData);

			if (response) {
				alert(isScheduled ? 'Email scheduled successfully!' : 'Email sent successfully!');
				setShowFeedbackEmailDialog(false);
				continueToNextPage();
			} else {
				alert(isScheduled ? 'Failed to schedule email' : 'Failed to send email');
			}
		} catch (error) {
			console.error('Error sending email:', error);
			alert('Error sending email');
		}
	}

	async function sendVehicleReceivedEmail() {
		const emailData = {
			customer_email: customerEmail,
			customer_name: customerName,
			received_by: receivedBy,
			dropped_off_by: droppedOffBy,
			ticket_id: currentTicketId,
			vehicle_name: customerVehicles?.find(vehicle=>vehicle.vehicle_id === _vehicleId).vehicle_name,
			license_plate: customerVehicles?.find(vehicle=>vehicle.vehicle_id === _vehicleId).license_plate.toUpperCase()
		};

		try {
			const response = await sendReceivedByEmail(emailData);

			if (response) {
				alert('Vehicle received email sent successfully!');
				setShowVehicleReceivedDialog(false);
				continueToNextPage();
			} else {
				alert('Failed to send vehicle received email');
			}
		} catch (error) {
			console.error('Error sending vehicle received email:', error);
			alert('Error sending vehicle received email');
		}
	}

	async function sendNextServiceEmail() {
		const emailData = {
			customer_email: customerEmail,
			customer_name: customerName,
			next_service_date: formatDate(nextServiceDate,false),
			ticket_id: currentTicketId,
			vehicle_name: customerVehicles?.find(vehicle=>vehicle.vehicle_id === _vehicleId).vehicle_name,
			license_plate: customerVehicles?.find(vehicle=>vehicle.vehicle_id === _vehicleId).license_plate.toUpperCase()
		};

		try {
			const response = await sendNextServiceNotification(emailData);

			if (response) {
				alert('Next service reminder email sent successfully!');
				setShowNextServiceDialog(false);
				setShowFeedbackEmailDialog(true);
			} else {
				alert('Failed to send next service reminder email');
			}
		} catch (error) {
			console.error('Error sending next service email:', error);
			alert('Error sending next service email');
		}
	}

	function continueToNextPage(){
		if((showFeedbackEmailDialog
			&& showNextServiceDialog
			&& showStatusDialog
			&& showVehicleReceivedDialog)){
			return;
		}
		if(_vehicleId){//service ticket
			navigate(`/dashboard/services/${customerVehicles.find(vehicle=>vehicle.vehicle_id === _vehicleId).license_plate}/${currentTicketId}`);
		}else{ // order ticket
			navigate(`/dashboard/members/u/${_customerId}/${currentTicketId}`);
		}

	}


	async function createTicket(){
		setIsSubmitting(true);
		const ticketType = urlParams.get("ticket_type");
		const ticketId = urlParams.get('ticket_id');

		let _ticketId = null;

		if(serviceItemsList.length === 0){
			alert("Can't add or edit a service item without any entries");
			setIsSubmitting(false);
			return;
		}

		const	payload = {
			"services" : serviceItemsList,
			"customer_id" : _customerId,
			"ticket_tag" : ticketTag
		}

		if(discountType != "None"){
			payload["discount_type"] = discountType;
			payload["discount_value"] = discountValue;
		}

		if(userPermission === "admin"){
			payload["sale_date"] = document.getElementById('sale_date').value;
		}


		if(_vehicleId){
			payload["vehicle_id"] = _vehicleId;
			if(ticketType === "order"){
				// converting from service ticket to order;
				alert("use case not implemented: converting from service ticket to order");
			}else if (ticketType === "service"){
				if (ticketId){// editing a service ticket
					payload["service_id"] = ticketId;

					_ticketId = ticketId;


					const response = await editVehicleServiceTicket(payload);
					const responseClone = response.clone();
					try{
						const result = await response.json();
						// navigate(`/dashboard/services/${vehicleData.license_plate}/${serviceId}`);

					}
					catch (e){
						console.log("response",await responseClone.text());
						alert("Something went wrong with edit ticket");
					}

				}
			}else{//creating a service ticket
				const response = await createVehicleServiceTicket(payload);
				const clonedResponse = response.clone();
				try{
					const result = await response.json();
					_ticketId = result.ticket_id;
					// navigate(`/dashboard/services/${vehicleData.license_plate}/${result.ticket_id}`);
				} catch (e){
					console.log('response',await clonedResponse.text());
					alert("Something went wrong with create ticket");

				}

			}
		}else{
			if(ticketType === "order"){
				if (ticketId){
					// editing an order ticket
					payload["order_id"] = ticketId;
					const response = await editOrderTicket(payload);
					const clonedResponse = response.clone();
					try {
						const result = await response.json();
						_ticketId = ticketId;
						// navigate(`/dashboard/members/u/${customerData.uuid}/${orderId}`);
					console.log('response', result)
					}catch(e){
						alert("Something went wrong");
						console.log("response",await clonedResponse.text(),e);
						setIsSubmitting(false);
						return;
					}
				}
			}else if (ticketType === "service"){
				// converting from service to order
				alert("Use case not implemented: converting from service to order");
			}else{
				// creating an order ticket
					const response = await createOrderTicket(payload);
					const clonedResponse = response.clone();
					try{
						const result = await response.json();
						_ticketId = result.order_id;
					} catch (e){
						console.log('response',await clonedResponse.text());
						alert("Something went wrong with create ticket");
						setIsSubmitting(false);
						return;
					}
			}
		}
		setIsSubmitting(false);

		setShowStatusDialog(_ticketId);

		setIsSubmitting(false);
	}


	function removeServiceItem(id){
		setServiceItemsList((prev) => prev.filter(item => item.item_id !== id));
	}


	function addServiceItem(event){
		event.preventDefault();
		const newItemName = document.getElementById('newRowEntry_itemName').textContent.trim();
		if(newItemName === _defaultNewItemName){
			alert("Please provide a name for the new item entry");
			return;
		}

		if (serviceItemsList.find(entry=> entry.item_name === newItemName)){
			alert(`You already have an entry with the name ${newItemName}. Please edit that entry instead`)
			return;
		}

		let newDescription =  document.getElementById('newRowEntry_description').textContent.trim();

		if(newDescription === _defaultNewItemDescription){
			newDescription = "";
		}


		const newItem = {
			item_id: Math.random().toString(36).substring(2, 9),
			item_name: newItemName,
			description: newDescription,
			unit: document.getElementById('newRowEntry_units').textContent.trim(),
			currency: "GHS",
			price : document.getElementById('newRowEntry_price').textContent.trim()
		};
		setServiceItemsList((prev)=> [...prev,newItem]);

		document.getElementById('newRowEntry_itemName').textContent = _defaultNewItemName;
		document.getElementById('newRowEntry_description').textContent = _defaultNewItemDescription;
		document.getElementById('newRowEntry_price').textContent = "";
		document.getElementById('newRowEntry_units').textContent = "";
		_setNewItemSubTotal(0);
	}


	useEffect(()=>{
		if(_customerList.length === 0){
			return;
		}

			const ticketType = urlParams.get("ticket_type");
			const ticketId = urlParams.get('ticket_id');
			//if we don't have a location state, then we didn't come through a
			// vehicle add serivce or customer add ticket interaction
			if(locationState === null){
				if(ticketType === "order"){
					getOrderDetails(ticketId).then((response)=>{
						// console.log("laoder",response);
						setServiceItemsList([]);
						response.order_ticket_items.forEach(item => {
							const newItem = {
								item_id: item.item_id,
								item_name: item.item_name,
								description: item.description,
								unit: item.units ?? 1,
								currency: item.currency ?? "GHS",
								price : item.price ?? ""
							};
							setServiceItemsList((prev) => [...prev, newItem]);

						});


						_setServiceDate(response.order_ticket_details.date_created.split(" ")[0]);
						response.order_ticket_details.tag_name && setTicketTag(Array.isArray(response.order_ticket_details.tag_name) ? response.order_ticket_details.tag_name : [response.order_ticket_details.tag_name]);

						if(response.ticket_discounts?.ticket_id){
							setDiscountType(capitalize(response.ticket_discounts.discount_type));
							setDiscountValue(response.ticket_discounts.discount_value);
						}

						setCustomerId(response.order_ticket_details.customer_id);
					}).catch((error)=> console.log('error occured with getOrderTicketItems',error));

				}else if (ticketType === "service"){

					getServiceDetails(ticketId).then((response)=>{
						setServiceItemsList([]);
						response.service_ticket_items.forEach(item => {
							const newItem = {
								item_id: item.item_id,
								item_name: item.item_name,
								description: item.description,
								unit: item.units,
								currency: item.currency ?? "GHS",
								price : item.price ?? ""
							};
							setServiceItemsList((prev) => [...prev, newItem]);
						});
						_setVehicleId(response.service_ticket_details["vehicle_id"]);
						setCustomerId(response.service_ticket_details["customer_id"]);

						if(response.ticket_discounts?.ticket_id){
							setDiscountType(capitalize(response.ticket_discounts.discount_type));
							setDiscountValue(response.ticket_discounts.discount_value);
						}
						_setServiceDate(response.service_ticket_details.date_created.split(" ")[0]);
						response.service_ticket_details.tag_name && setTicketTag(Array.isArray(response.service_ticket_details.tag_name) ? response.service_ticket_details.tag_name : [response.service_ticket_details.tag_name]);

					}).catch((error)=> console.log('error occured with getServiceTicketItems',error));

				}
			}else{
				setCustomerId(locationState.customer_id);
			}
	},[_customerList]);

	useEffect(()=>{
		mixpanel.identify(getUserId());
		// try{
			setIsCustomerListLoading(true);
			getCustomers().then(response=>{
				_setCustomerList(response.customers);
			}).finally(()=>setIsCustomerListLoading(false));

			_getServiceItems().then(response=>{
				let temp = [];
				response.items.forEach((item)=>temp.push(item.item_name));
				_setServiceItems(temp);
			}).catch((eo)=>console.log("error occured with _getServiceItems",eo));

			_getTicketTagOptions().then(response=>{
				let temp = [];
				response.tags.forEach((tag)=>temp.push(tag.tag_name));
				_setticketTags(temp);

			}).catch((e)=>{
				console.log("error occured with _getTicketTagOptions",e);
			});

			try{
				_getTicketStatusOptions().then((statuses)=>{
					const map = statuses.statuses.map((stat)=>stat.status);
					_setStatusOptions(map);
				});
			} catch(e){
				console.log('something went wrong with _getTicketStatusOptions')
			}


	},[]);


	useEffect(()=>{
		_setIsLoadingVehicles(true);
		_customerId && getCustomerVehicles(_customerId).then((response)=>{
			setCustomerVehicles([...response.vehicles,{"vehicle_name": "No Vehicle","vehicle_id":undefined}]);
		});
		_setIsLoadingVehicles(false);
		if(canPopulate.current && locationState?.vehicle_id){
			_setVehicleId(locationState.vehicle_id);
			canPopulate.current = false;
		}
	},[_customerId]);



const subTotal = serviceItemsList.reduce((sum, item) => {
		if (item.price && !isNaN(Number(item.price))) {
			 return sum+ (Number(item.price)*Number(item.unit));
		}

	}, 0);

const discountAmount = discountType == "Percentage" ? ((discountValue)/100) * subTotal
: (discountType == "Amount" ? discountValue : 0);


const totalPrice = subTotal - discountAmount;

	return (
		<main id="AddVehicleService">
			<h1>{urlParams.get('ticket_id') ? "Edit" : "Create"} Create Ticket</h1>
			{
				_customerId ?
					<Link to={`/dashboard/members/u/${_customerId}/services`}>{`${_customerList.find((e)=>e.uuid === _customerId).first_name} ${_customerList.find((e)=>e.uuid === _customerId).last_name}`}'s services</Link>
				:
					<Link to="/dashboard/services">Return to All Services</Link>
			}
			<div id="page-detail-card">
				<div id="header-section">
					<div id="middle">
						<div className="col">
							<ESelect
								// onMenuClose={(e)=>console.log("closed")}
								onInputChange={(e)=>_setCustomerFilter(e)}
								noOptionsMessage={()=>"No Customers Found"}
								placeholder="Select A Customer"
								onChange={(option)=> setCustomerId(option.value)}
								isLoading={_isCustomerListLoading}
								loadingMessage={"Loading Customer List"}
								value={!_customerId ? "" :{
									value: _customerId,
									label: `${_customerList.find(customer=>customer.uuid == _customerId).first_name} ${_customerList.find(customer=>customer.uuid == _customerId).other_names} ${_customerList.find(customer=>customer.uuid == _customerId).last_name}`
								}}
								// value={{value: _customerId,"label":customer`${_customerList[3]?.first_name} ${_customerList[3]?.other_names} ${_customerList[3]?.last_name}`}}
								options={_customerList.map((customer) => ({
									value: customer.uuid,
									label: `${customer.first_name} ${customer.other_names} ${customer.last_name}`
								})).filter(option =>
									option.label.toLowerCase().includes(_customerFilter.toLowerCase().trim())
								)}
							/>
						</div>

						<ESelect
							noOptionsMessage={()=>"No Vehicles Found"}
							placeholder="Select A Vehicle"
							// defaultInputValue={_vehicleId}
							onChange={(e)=>_setVehicleId(e.value)}
							isSearchable={false}
							value={!customerVehicles.find(vehicle=>vehicle.vehicle_id === _vehicleId) ? "" :{
									value: _vehicleId,
									label: `${customerVehicles.find(vehicle=>vehicle.vehicle_id === _vehicleId).license_plate} - ${customerVehicles.find(vehicle=>vehicle.vehicle_id === _vehicleId).vehicle_name} (${customerVehicles.find(vehicle=>vehicle.vehicle_id === _vehicleId).vehicle_year})`
								}}
							isLoading={_isLoadingVehicles}
							loadingMessage={()=>"Loading Customers vehicles"}
							options={customerVehicles.map((vehicle)=>
								vehicle.vehicle_id===undefined ?
								{value:undefined,label:"Non-vehicle related entry"}
								:
									{
										value: vehicle.vehicle_id,
										label: `${vehicle.license_plate} - ${vehicle.vehicle_name} (${vehicle.vehicle_year})`
									}
								)}
						/>

						<h4>Total: <strong>GHS {totalPrice}</strong></h4>

					</div>
					<div id="end">
						<Button
							color={isSubmitting ? "black":"green"}
							label={isSubmitting ? "Submitting...." :(`${urlParams.get('ticket_id')  ?"Edit":"Create"} Ticket`)}
							onClick={createTicket}
							disabled={isSubmitting}
						/>
					</div>
				</div>
				<div className="card p-1">
					<div className="row space-around">
						<div>
							<ESelect
								noOptionsMessage={()=>"No Service Types Found"}
								placeholder="Select Type of Service"
								onChange={(options)=> setTicketTag(options ? options.map(opt => opt.value) : [])}
								isSearchable={true}
								isMulti={true}
								value={!ticketTag ? [] : ticketTag.map(tag => ({
									value: tag,
									label: tag
								}))}
								options={_ticketTags.map((tag) => ({
									value: tag,
									label: tag
								}))}
							/>
						</div>
						<div className="discount">
							<Select
								label="Discount Type"
								options = {["None","Percentage","Amount"]}
								defaultValue={discountType}
								onChange={(newVal)=>setDiscountType(newVal.target.value)}
							/>
							{discountType != "None" && <TextField
								label="Discount"
								value={discountValue}
								onChange={(event)=>setDiscountValue(event.target.value)}
								subLabel={`(${discountType == "None" ? "" :(discountType == "Percentage" ? "%" : "GHS")})`}
								disabled={discountType == "None"}
							/>}
						</div>

						<div>
							{userPermission !== "basic" &&<TextField
								label="Date of Sale"
								type="date"
								value={_serviceDate}
								onChange={(event)=> _setServiceDate(event.target.value)}
								id="sale_date"
							/>}
						</div>
					</div>
				</div>
				<div id="service-ticket-items">
					<table className="invoice-table">
						<thead>
							<tr>
								<th>Ticket Item Name</th>
								<th>Units</th>
								<th>Unit Price</th>
								<th>Sub Total</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>


							<tr key="newRowEntry"
									style={{ backgroundColor: "#dadce1",borderBottom: "4px solid var(--primary)" }}>
										<td>
											<span
												id="newRowEntry_itemName"
												contentEditable
												suppressContentEditableWarning
												onFocus={(e)=>{
													if (e.target.innerText == _defaultNewItemName){
														e.target.innerText = "";
													}
												}}
												onBlur={(e)=>{
													const textVal = e.target.textContent;
													if(textVal.trim() === ""){
														e.target.textContent = _defaultNewItemName;
													}
												}}
											>{_defaultNewItemName}</span>
											<p
												id="newRowEntry_description"
												contentEditable
												className="description"
												style={{"marginTop" : "2em"}}
												suppressContentEditableWarning
												onFocus={(e)=>{
													if (e.target.innerText == _defaultNewItemDescription){
														e.target.innerText = "";
													}
												}}
												onBlur={(e)=>{
													const textVal = e.target.textContent;
													if(textVal.trim() === ""){
														e.target.textContent = _defaultNewItemDescription;
													}
												}}

											>{_defaultNewItemDescription}</p>
										</td>
										<td
											id="newRowEntry_units"
											contentEditable
											suppressContentEditableWarning
											onBlur={(e) => {
												const value = e.target.textContent.trim();
												if (value === ""){
													return;
												}
												if (!/^\d+$/.test(value)) {
													alert("This value must be a number");
													e.target.textContent = "";
													_setNewItemSubTotal(0);
													return;
												}
												const price = Number(document.getElementById("newRowEntry_price").textContent);
												_setNewItemSubTotal(Number(value) * price);
											}}
										></td>
										<td
											id="newRowEntry_price"
											contentEditable
											suppressContentEditableWarning
											onBlur={(e) => {
												const value = e.target.textContent.trim();
												if (!value==="" && !/^\d+$/.test(value)) {
													alert("This value must be a number");
													e.target.textContent = "";
													_setNewItemSubTotal(0);
													return;
												}
												const units = Number(document.getElementById("newRowEntry_units").textContent);
												_setNewItemSubTotal(Number(value) * units);
											}}
										></td>
										<td>
											GHS {_newItemSubTotal}
										</td>
										<td>
											<a href="#"  onClick={addServiceItem} onFocus={(e)=>{
												addServiceItem(e);
												document.getElementById("newRowEntry_itemName").focus();
											}}>Add Item</a>
										</td>
							</tr>
								{
									serviceItemsList.map((element,index)=> (
										<tr key={element.item_id} id={element.item_id} >
									<td>

										<span
											contentEditable
											suppressContentEditableWarning
											onBlur={(e)=> {
												const newValue = e.target.textContent;
												setServiceItemsList((prev) => {
													const updated = prev.map(item =>
														item.item_id === element.item_id
															? { ...item, item_name: newValue }
															: item
												);
												return updated;
											});

										}}
									>
										{element.item_name}</span>
									<p
										className="description"
										contentEditable
										suppressContentEditableWarning
										onBlur={(e)=> {
											const newValue = e.target.textContent;
											setServiceItemsList((prev) => {
												const updated = prev.map(item =>
													item.item_id === element.item_id
														? { ...item, description: newValue }
														: item
												);
												return updated;
											});

										}}
									>
										{element.description}
									</p>
								</td>
								<td
									contentEditable
									suppressContentEditableWarning
									onBlur={(e)=>{
											const value = e.target.textContent;
										if (!value==="" && !/^\d+$/.test(value)) {
											alert("This value must be a number");
											e.target.textContent = 0;
											return;
										}
										setServiceItemsList((prev)=>{
											const updated = prev.map(item=>
												item.item_id===element.item_id
												? {...item, unit : value}
												: item
											);
											return updated;
										})
									}}
								>
									{element.unit}
								</td>
								<td>
									{element.price == "" ? "n/a":`${element.currency} `}
									{
										element.price == "" ? "n/a"
										:<span
										contentEditable
										suppressContentEditableWarning
										onBlur={(e)=>{
											const value = e.target.textContent;
										if (!value==="" && !/^\d+$/.test(value)) {
											alert("This value must be a number");
											e.target.textContent = 0;
											return;
										}
										setServiceItemsList((prev)=>{
											const updated = prev.map(item=>
												item.item_id===element.item_id
												? {...item, price : value}
												: item
											);
											return updated;
										})
										}}
										>{element.price}
										</span>
									}
								</td>

								<td>{element.price === "" ? "n/a":`${element.currency} ${Number(element.price)*Number(element.unit)}`}</td>
								<td className="action-cell">
									<Link className="red-text"
									onClick={() => removeServiceItem(element.item_id)}
									>Remove</Link>
								</td>
							</tr>)
								)
							}



							<tr className="grey-text">
								<td></td>
								<td></td>
								<td>Sub total</td>
								<td>GHS { subTotal}</td>
								<td></td>
							</tr>
							{discountType != "None" && <tr className="grey-text">
								<td></td>
								<td></td>
								<td>
									Discount
									{` (${discountType == "None" ? "" :(discountType == "Percentage" ? ` ${discountValue}% ` : "GHS")})`}
								</td>
								<td>GHS {discountAmount}</td>
								<td></td>
							</tr>}
							<tr>
								<td></td>
								<td></td>
								<td>TOTAL</td>
								<td>GHS {totalPrice}</td>
								<td></td>
							</tr>




						</tbody>
					</table>
				</div>
			</div>

			{showStatusDialog && (
				<div className="dialog-overlay">

					<div className="dialog" >
						<Form id="changeStatusForm" onSubmit={updateStatus}>
							<div className="dialog-header">
								<h3>Change Status</h3>
							</div>
							<div className="dialog-content">
								<div className="row">
									<div className="col-3">
										<Select
											label="Status"
											options={_statusOptions}
											name="status"
											defaultValue={_currentService?.status ?? "open"}
											// value={currencyField}
											// onChange={(e) => set(e.target.value)}
										/>

									</div>
								</div>
							</div>
							<div className="dialog-footer">
								<Button onClick={()=> {
										setShowStatusDialog(false);
										continueToNextPage();
									}} color="red" label="Keep Current Status"/>
								<Button type="submit" label="Update Status" color="green" />
							</div>
						</Form>
					</div>
				</div>
			)}

			{showFeedbackEmailDialog && (
				<div className="dialog-overlay">
					<div className="dialog">
						<div className="dialog-header">
							<h3>Ask For Feedback</h3>
						</div>
						<div className="dialog-content">
							<div className="row">
								<div className="col">
									<TextField
										label="Customer Name"
										type="text"
										value={customerName}
										onChange={(e) => setCustomerName(e.target.value)}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col">
									<TextField
										label="Customer Email"
										type="email"
										value={customerEmail}
										onChange={(e) => setCustomerEmail(e.target.value)}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col">
									<TextField
										label="Scheduled Email Date"
										type="date"
										value={scheduledEmailDate}
										onChange={(e) => setScheduledEmailDate(e.target.value)}
									/>
									<Button
										onClick={() => sendEmail(false)}
										color="green"
										label="Send Now"
									/>
								</div>
							</div>
						</div>
						<div className="dialog-footer">
							<Button
								onClick={() => {
									setShowFeedbackEmailDialog(false);
									continueToNextPage();
								}}
								color="red"
								label="Don't Send"
							/>
							<Button
								onClick={() => sendEmail(true)}
								color="blue"
								label="Schedule Email"
							/>
						</div>
					</div>
				</div>
			)}

			{showVehicleReceivedDialog && (
				<div className="dialog-overlay">
					<div className="dialog">
						<div className="dialog-header">
							<h3>Vehicle Received Notification</h3>
						</div>
						<div className="dialog-content">
							<div className="row">
								<div className="col">
									<TextField
										label="Customer Name"
										type="text"
										value={customerName}
										onChange={(e) => setCustomerName(e.target.value)}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col">
									<TextField
										label="Customer Email"
										type="email"
										value={customerEmail}
										onChange={(e) => setCustomerEmail(e.target.value)}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col">
									<TextField
										label="Received By"
										type="text"
										value={receivedBy}
										onChange={(e) => setReceivedBy(e.target.value)}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col">
									<TextField
										label="Dropped Off By"
										type="text"
										value={droppedOffBy}
										onChange={(e) => setDroppedOffBy(e.target.value)}
									/>
								</div>
							</div>
						</div>
						<div className="dialog-footer">
							<Button
								onClick={() => {
									setShowVehicleReceivedDialog(false);
									continueToNextPage();
								}}
								color="red"
								label="Don't Send"
							/>
							<Button
								onClick={() => sendVehicleReceivedEmail()}
								color="green"
								label="Send Email"
							/>
						</div>
					</div>
				</div>
			)}

			{showNextServiceDialog && (
				<div className="dialog-overlay">
					<div className="dialog">
						<div className="dialog-header">
							<h3>Next Service Reminder</h3>
						</div>
						<div className="dialog-content">
							<div className="row">
								<div className="col">
									<TextField
										label="Customer Name"
										type="text"
										value={customerName}
										onChange={(e) => setCustomerName(e.target.value)}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col">
									<TextField
										label="Customer Email"
										type="email"
										value={customerEmail}
										onChange={(e) => setCustomerEmail(e.target.value)}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col">
									<TextField
										label="Next Service Date"
										type="date"
										value={nextServiceDate}
										onChange={(e) => setNextServiceDate(e.target.value)}
									/>
								</div>
							</div>
						</div>
						<div className="dialog-footer">
							<Button
								onClick={() => setShowNextServiceDialog(false)}
								color="red"
								label="Don't Send"
							/>
							<Button
								onClick={() => sendNextServiceEmail()}
								color="green"
								label="Send Reminder"
							/>
						</div>
					</div>
				</div>
			)}
		</main>
	);
}